export const USER_DATA_COLLECTION_CONSTANT = [
  {
    title: "Jenis Informasi yang Kami Kumpulkan?",
    description: `
      <p>Data pribadi yang Kami peroleh dari Anda (&ldquo;Pemilik Data&rdquo;) baik secara langsung maupun tidak langsung melalui sistem elektronik dan/atau non-elektronik dapat mencakup namun tidak terbatas pada hal-hal berikut:</p>

      <ol>
        <li>
          <strong>Informasi Pribadi</strong>
          <br />
          Termasuk nama, tanggal lahir, usia, jenis kelamin, nomor induk kependudukan atau yang setara dengan itu, status perkawinan, kartu keluarga dan pekerjaan. 
        </li>

        <li>
          <strong>Kontak Pribadi</strong>
          <br />
          Termasuk nomor telepon, dan alamat surel/email.
        </li>

        <li>
          <strong>Informasi Finansial</strong>
          <br />
          Termasuk nomor rekening bank, pembayaran, penghasilan, dan detail keuangan lainnya. 
        </li>

        <li>
          <strong>Informasi Kesehatan</strong><br />
          Termasuk berat badan, tinggi badan, rekam medis, polis asuransi lain yang dimiliki, riwayat/sejarah rawat inap, kebiasaan merokok, keadaan kesehatan yang sudah ada sebelumnya (<em>pre-existing conditions</em>), riwayat/sejarah medis keluarga, dan informasi lain yang Anda berikan kepada kami sehubungan dengan riwayat/sejarah kesehatan Anda atau keluarga Anda. 
        </li>

        <li>
          <strong>Informasi Kendaraan</strong><br />
          Termasuk merek kendaraan, tipe kendaraan, tahun pembuatan, aksesoris, nomor mesin, nomor rangka, plat nomor, STNK atau yang setara dengan itu, dan SIM pengemudi atau yang setara dengan itu, serta detail lainnya. 
        </li>

        <li>
          <strong>Informasi Lainnya</strong><br />
          Termasuk pendapat Anda, wawasan Anda tentang produk yang digunakan dan referensi, informasi pribadi lainnya yang digunakan untuk produk atau layanan ini baik yang diwajibkan ataupun tidak oleh undang-undang, peraturan, regulasi, pemberitahuan, surat edaran, arahan, pedoman, kode etik, dan/atau peraturan pemerintah. 
        </li>

        <li>
          <strong>Informasi Digital </strong><br />
          Untuk kebutuhan Layanan yang kami berikan, kami mungkin saja pada bagian tertentu akan meminta untuk mengumpulkan, menggunakan atau mengakses hal-hal sebagai berikut:

          <ul>
            <li>lokasi GPS Anda untuk mendukung pencarian layanan terdekat;</li>
            <li>kamera dan audio untuk memungkinkan komunikasi; dan/atau</li>
            <li>file dan gambar Anda untuk memungkinkan pengunggahan file.</li>   
          </ul>
        </li>
      </ol>
    `,
  },
  {
    title: "Bagaimana Kami Mengumpulkan Informasi di Atas?",
    description: `
     <ol style="list-style-type: lower-alpha;">
      <li>
        <strong>Melalui Situs Web Kami</strong>
        <br />
        Informasi Anda dikumpulkan saat Anda mengunjungi, mendaftar, melakukan transaksi atau berinteraksi dengan Situs Web kami.
      </li>

      <li>
        <strong>Pernyataan Langsung </strong>
        <br />
        Informasi Anda dikumpulkan saat Anda secara aktif memberikan data kepada kami ketika anda meminta produk atau Layanan kami.
      </li>

      <li>
        <strong>Informasi dari Pihak Ketiga</strong>
        <br />
        Kami juga dapat mengumpulkan informasi dari orang-orang terkait dengan Anda atau yang Anda tunjuk, seperti pasangan, anggota keluarga, atau pihak lain yang terlibat dalam proses permohonan, klaim, dan kompensasi. 
      </li>

      <li>
        <strong>Sumber Pihak Ketiga</strong>
        <br />
        Kami menerima informasi dari pihak ketiga yang relevan, termasuk tetapi tidak terbatas pada perusahaan asuransi, lembaga keuangan, badan pengawas seperti OJK, DJP, DUKCAPIL, PPATK, POLRI, serta asosiasi terkait seperti AAUI dan AAJI. Jika Anda memberikan informasi tentang orang lain kepada kami, adalah tanggung jawabmu untuk memastikan bahwa mereka telah menyetujui pengungkapan informasi mereka dan memahami ketentuan dalam Kebijakan Privasi ini.
      </li>

      <li>
        <strong>Inspeksi Kendaraan</strong>
        <br />
        Informasi juga dikumpulkan saat Anda melakukan inspeksi kendaraan bermotor bersama kami.
      </li>

      <li>
        <strong>Informasi Pihak Ketiga dari Anda</strong>
        <br />
        Setiap Informasi atau Data Pribadi yang Anda kirimkan atau dengan cara lain membuat Informasi Pribadi yang berkaitan dengan individu atau pihak lain Anda sediakan kepada Kami maka Anda menyatakan bahwa Anda berhak untuk menyediakan informasi tersebut kepada Kami dan bahwa Anda telah memperoleh persetujuan yang diperlukan dan diwajibkan sebelumnya dari mereka untuk penggunaan Kami sesuai dengan Kebijakan Privasi ini dan semua persetujuan sebelumnya yang mungkin diperlukan berdasarkan undang-undang dan peraturan yang berlaku, kontrak, atau sebaliknya untuk mengungkapkan Informasi Pribadi tersebut kepada Kami dan untuk Kami kumpulkan, gunakan, akses, simpan, ungkapkan, dan/atau proses Informasi Pribadi tersebut (baik secara keseluruhan, sebagian dan/atau yang dimodifikasi/diproses/ diubah) sesuai dengan Kebijakan Privasi ini.  
      </li>
    </ol>
    `,
  },
  {
    title: "Mengapa Kami Mengumpulkan Data dan Bagaimana Kami Mengelolanya?",
    description: `
      <p>
        Kami mengumpulkan dan menggunakan informasi pribadi Anda untuk beberapa tujuan utama seperti:
      </p>

      <ol style="list-style-type: lower-alpha;">
        <li>
          memenuhi kewajiban layanan Kami, dan untuk memproses permintaan atau transaksi apa pun pada Situs Web ini, memberikan informasi terkait layanan atau produk kami;
        </li>

        <li>
          Untuk administrasi Situs Web dan operasi bisnis kami;
        </li>

        <li>
          Untuk memenuhi kewajiban sesuai dengan yang disyaratkan dalam perundang-undangan asuransi, perundang-undangan perlindungan data pribadi, dan perundang-undangan terkait lainnya yang berlaku;
        </li>

        <li>
          Untuk mengolah serta memberi tanggapan atas pertanyaan maupun saran yang Anda sampaikan;
        </li>

        <li>
          Untuk memberitahu Anda mengenai segala pembaruan pada aplikasi, Situs Web maupun layanan yang Kami sediakan;
        </li>

        <li>
          Untuk mengidentifikasi, mengadministrasikan, memverifikasi, menonaktifkan, atau mengelola akun Anda dalam hal Anda sebagai Pengguna;
        </li>

        <li>
          Untuk menyediakan, menyesuaikan, menjaga, dan meningkatkan layanan aplikasi, Situs Web, dan layanan Kami;
        </li>

        <li>
          Sebagai media berkomunikasi serta menginformasikan sehubungan dengan penggunaan aplikasi, Situs Web maupun layanan Kami, komunikasi pemasaran
        </li>

        <li>
          untuk tujuan pelatihan dan keamanan;
        </li>

        <li>
          untuk analisis data, riset pasar, survei, kuesioner;
        </li>

        <li>
          Untuk kepentingan pengadilan atau diminta oleh badan pemerintah mana pun sesuai dengan  hukum yang berlaku;
        </li>

        <li>
          Untuk tujuan lain apapun yang dipandang perlu oleh Kami selain tujuan lain di atas.
        </li>
      </ol>

      <p>
        Seluruh pengungkapan, penggunaan, pemrosesan Informasi pribadi apapun Milik Anda akan digunakan setelah mendapat izin dari Anda. 
      </p>
    `,
  },
  {
    title: "Untuk keamanan data pribadi Anda, kami...",
    description: `
      <ol style="list-style-type: lower-alpha;">
        <li>
          Menggunakan teknologi enkripsi dan tokenisasi untuk melindungi data sensitif, seperti nomor kartu kredit, yang hanya dapat diakses oleh pihak yang berwenang.
        </li>

        <li>
          Pembatasan akses data pribadi, artinya hanya karyawan yang berwenang yang bisa mendapatkan akses informasi pribadi Anda.
        </li>

        <li>
          Melakukan pembaruan teknologi sistem kami secara rutin untuk mencegah akses yang tidak sah.
        </li>

        <li>
          Melakukan penghapusan data pribadi Anda ketika sudah tidak diperlukan lagi.
        </li>

        <li>
          Menggunakan langkah-langkah administratif, teknis, fisik atau praktik keamanan yang dianggap perlu untuk menunjang proses pelindungan data Anda dan para pengguna Situs Web dan Layanan kami.
        </li>

        <li>
          mewajibkan penyedia pihak ketiga kami untuk menerapkan tindakan keamanan teknis, administratif, dan fisik pada tingkat yang sama dalam menangani informasi pribadi Anda.
        </li>
      </ol>
    `,
  },
  {
    title: "Pelindungan Data Untuk Anak-Anak Di Bawah Umur ",
    description: `
      <p>
        Layanan yang Kami berikan hanya ditujukan bagi pengguna yang telah berusia minimal 18 (delapan belas) tahun atau yang sudah menikah. Pengguna di bawah usia tersebut ("Anak") wajib mendapatkan izin dan pendampingan dari orang tua atau wali yang sah sebelum melakukan pendaftaran dan memberikan Data Pribadi apa pun.
      </p>

      <p>
        Dengan mendaftarkan akun untuk Anak, orang tua atau wali menyatakan dan menjamin bahwa mereka bertindak untuk dan atas nama Anak, serta memberikan persetujuan eksplisit kepada Kami untuk mengumpulkan, memproses, dan menyimpan Data Pribadi Anak sesuai dengan Kebijakan Privasi ini. 
      </p>

      <p>
        Kami berhak melakukan verifikasi usia kapan saja. Jika ditemukan bahwa Anak telah mendaftar tanpa persetujuan orang tua atau wali yang sah, atau jika orang tua/wali menarik persetujuannya maka Kami berhak secara sepihak untuk:
      </p>

      <ul>
        <li>
          Membatalkan pendaftaran akun tersebut secara seketika;
        </li>

        <li>
          Menghentikan akses terhadap Layanan; dan 
        </li>

        <li>
          Menghapus seluruh Data Pribadi Anak dari sistem kami, kecuali ditentukan lain oleh peraturan perundang-undangan yang berlaku. 
        </li>
      </ul>
    `,
  },
  {
    title: "Jika Anda ingin membatalkan persetujuan Anda",
    description: `
      <p>
        Jika Anda tidak ingin informasi pribadi Anda digunakan, diungkapkan, atau diproses, Anda dapat setiap saat menghubungi Kami pada Kontak yang tersedia baik melalui email maupun telepon. 
      </p>
    `,
  },
  {
    title: "Berapa Lama Kami Menyimpan Informasi Nasabah?",
    description: `
      <p>
        Kami akan menyimpan informasi pribadi Anda selama diperlukan untuk tujuan pengumpulan dan penggunaan tersebut, kecuali jika diwajibkan atau diizinkan oleh hukum yang berlaku. Umumnya, informasi pribadi akan disimpan minimal selama 5 (lima) tahun setelah polis Anda berakhir atau dibatalkan dan/atau sesuai dengan peraturan yang berlaku atau kebijakan sehubungan dengan data/informasi.
      </p>

      <p>
        Untuk informasi keuangan terkait dengan data anda, seperti jumlah premi, klaim, dan pembayaran lainnya, kami akan menyimpannya setidaknya 10(sepuluh) tahun setelah polis asuransi berakhir atau dibatalkan, sesuai dengan peraturan mengenai Dokumen Perusahaan. 
      </p>

      <p>
        Menyimpang dari ketentuan-ketentuan di atas, Kami dapat melakukan penyimpanan data sesuai dengan ketentuan retensi penyimpanan data Kami, lebih lama dari batas waktu yang ditentukan ,jika hal tersebut diperlukan untuk kebutuhan hukum, pembuktian di kemudian hari, membantu mendeteksi kejahatan keuangan, menjawab permintaan regulator atau aparat yang berwenang, dan hal lainnya. Data Pribadi Anda disimpan selama tujuan pengumpulannya masih diperlukan untuk tujuan hukum atau kepentingan bisnis lainnya.   
      </p>
    `,
  },
  {
    title: "Keamanan Data Pribadi oleh Anda",
    description: `
      <p>
        Kerja sama Anda sangat diharapkan untuk mengurangi dan menghindari akses tidak sah terhadap Informasi Pribadi Anda dengan menggunakan praktik keamanan minimum baik pada perangkat pribadi Anda ataupun perangkat lani sehubungan dengan Layanan dan Situs Web ini. Misalnya, Anda bertanggung jawab untuk menerapkan langkah-langkah keamanan yang tepat untuk mengontrol akses ke perangkat dan sistem komputer Anda, termasuk membuat kata sandi yang kuat yang tidak dapat dengan mudah ditebak oleh orang lain (misalnya, dengan menyertakan tanda baca, angka, huruf kapital dan kecil, serta memilih kata sandi dengan panjang yang sesuai dan yang tidak mencakup nama Anda atau nama akun Anda), menggunakan kata sandi yang berbeda untuk layanan yang berbeda, menjaga kerahasiaan dan keamanan kata sandi dan/atau kode OTP Anda, tidak berbagi akses ke email atau perangkat Anda, mengatur kode akses yang memadai untuk membuka kunci perangkat Anda, menjaga email dan/atau nomor telepon Anda tetap terkini, dan menggunakan perangkat lunak antivirus yang mutakhir. Harap dicatat bahwa Kami tidak akan pernah menghubungi Anda untuk meminta pengungkapan kata sandi atau kode OTP Anda. 
      </p>
    `,
  },
  {
    title: "Kebenaran Informasi dan Data, Koreksi  Atau Mengubah Data Pribadi",
    description: `
      <p>
        Kami senantiasa mengambil langkah-langkah yang wajar untuk memastikan bahwa Informasi Pribadi yang kami kelola tetap akurat, lengkap, dan mutakhir. Namun demikian, Kami tidak bertanggung jawab untuk melakukan verifikasi maupun penyelidikan independen atas keakuratan, legalitas, atau keabsahan informasi tersebut. Kami mengandalkan Anda untuk melakukan pembaruan atau perbaikan atas Informasi Pribadi apabila diperlukan. Dengan memberikan data kepada kami, Anda harus memastikan, menyatakan dan menjamin bahwa seluruh informasi yang disampaikan adalah benar, lengkap, tidak menyesatkan, tidak kadaluwarsa, serta dapat diandalkan untuk tujuan yang sah.
      </p>

      <p>
        Apabila Anda menemukan ketidaksesuaian dengan data yang Kami kumpulkan, maka Anda dapat mengirim permintaan pembaruan/perbaikan Data Pribadi yang nantinya akan Kami perbarui melalui kontak yang tersedia baik email ataupun telepon yang akan diperbaiki dalam jangka waktu paling lambat 3 x 24 (tiga kali dua puluh empat) jam terhitung sejak Kami menerima permintaan pembaruan/perbaikan data yang Anda kirimkan.
      </p>

      <p>
        Pembaharuan diperlukan untuk memastikan bahwa syarat ketentuan dan kebijakan privasi Kami mempunyai validitas dan akurasi yang tajam dalam perkembangan teknologi dan kebutuhan Pengguna dari masa ke masa. Pengajuan perubahan data yang disampaikan merupakan bentuk persetujuan dari Anda kepada kami untuk melakukan perubahan. Kami tidak bertanggung jawab atas tindakan Kami dalam mengandalkan informasi pribadi yang tidak lengkap, tidak akurat atau tidak benar karena Anda tidak memperbarui informasi tersebut kepada Kami. 
      </p>
    `,
  },
  {
    title: "Akses Pihak Ketiga",
    description: `
      <p>
        Untuk memenuhi kewajiban kontraktual kami terhadap nasabah atau kewajiban kami kepada regulator dan otoritas terkait, informasi pribadi Anda dapat kami ungkapkan atau bagikan kepada pihak ketiga hanya untuk tujuan yang telah disebutkan. Pihak ketiga ini mungkin termasuk perusahaan asuransi, perusahaan reasuransi, mitra bisnis kami, lembaga keuangan, regulator seperti OJK (Otoritas Jasa Keuangan), otoritas seperti DJP (Direktorat Jendral Pajak), PPATK (Pusat Pelaporan dan Analisis Transaksi Keuangan), POLRI (Kepolisian Republik Indonesia), atau instansi pemerintah lainnya, serta penyedia layanan lainnya, seperti penyedia penyimpanan data, layanan call center, layanan First Notice of Loss, jasa pembayaran atau payment gateway, rumah sakit, klinik kesehatan, penyedia layanan kesehatan lainnya, bengkel, penyedia sistem klaim, dan salvage buyer.
      </p>

      <p>
        Selain itu, untuk meningkatkan pengalaman Anda saat menggunakan Situs Web, kami akan memantau perilaku Anda menggunakan alat analitik. Alat analitik ini disediakan oleh pihak ketiga yang kami tunjuk, dan kami memiliki hak untuk menambah, menghentikan, atau mengganti penyedia yang ada dengan penyedia analitik pihak ketiga lainnya. Informasi yang dikumpulkan untuk tujuan ini akan bersifat anonim dan tidak dapat diidentifikasi sebagai milik Anda. 
      </p>

      <p>
        Untuk operasi bisnis kami, di mana kepentingan sah kami sama pentingnya dengan hak dasar subjek data, informasi pribadi Anda dapat diungkapkan atau dibagikan kepada perusahaan grup kami/afiliasi dan pihak ketiga lainnya, seperti auditor eksternal, penasihat, penyedia layanan survei atau analisis data, dan investor.
      </p>

      <p>
        <strong>Dalam situasi apa pun, informasi pribadi Anda tidak akan diungkapkan atau dibagikan kepada pihak lain selain yang disebutkan di atas, tanpa persetujuan Anda, kecuali dalam kondisi berikut: </strong>
      </p>

      <ol>
        <li>
          Diperlukan oleh peraturan perundang-undangan yang berlaku;
        </li>

        <li>
          Diperlukan untuk mencegah keadaan darurat atau melindungi keselamatan individu;
        </li>

        <li>
          Untuk kepentingan umum.
        </li>
      </ol>

      <p>
        Jika kami harus mengungkapkan atau membagikan informasi pribadimu kepada pihak ketiga, kami akan memastikan bahwa pihak ketiga tersebut diberitahukan tentang sifat kerahasiaan informasi tersebut dan diwajibkan untuk membatasi penggunaannya hanya untuk tujuan yang diizinkan dan sesuai dengan kebijakan ini serta peraturan perundang-undangan yang berlaku di Indonesia mengenai perlindungan data pribadi. 
      </p>
    `,
  },
  {
    title: "Transfer Lintas Batas",
    description: `
      <p>
        Terkait dokumentasi, informasi pribadi Anda akan disimpan di Indonesia. Sementara itu, informasi non-pribadi akan disimpan di luar Indonesia menggunakan metode enkripsi dan tokenisasi yang telah dijelaskan sebelumnya. Tidak ada informasi pribadi Anda yang secara langsung merujuk pada Anda akan disimpan di luar negeri. Namun, kami akan memastikan bahwa langkah-langkah yang diperlukan diambil untuk menyimpan dan melindungi informasi pribadi Anda dengan aman. Anda memahami dan menyetujui transfer Informasi Pribadi Anda keluar dari negara asal Anda dan/atau Negara Asal sebagaimana dijelaskan dalam Kebijakan Privasi ini.
      </p>
    `,
  },
  {
    title: "Hak Subjek Data",
    description: `
      <p>
        Lifepal tunduk pada peraturan perundang-undangan yang berlaku di Indonesia terkait perlindungan data pribadi. Oleh karenanya , dengan menggunakan Situs Web Kami, Anda setuju untuk menerima layanan Kami, dan/atau membeli produk Anda, data pribadi Anda akan dilindungi melalui proses berikut:
      </p>

      <ol style="list-style-type: lower-alpha;">
        <li>
          <strong>Perolehan dan Pengumpulan Data</strong>
          <br />
          Sesuai dengan peraturan perlindungan data pribadi yang berlaku di Indonesia, perolehan dan pengumpulan data pribadi dilakukan dengan menghormati hak-hak yang dimiliki pemilik data. Kami memungkinkan Anda untuk melakukan perubahan, penambahan, atau pembaruan informasi tersebut. Pengumpulan dan perolehan data pribadi dilakukan berdasarkan persetujuan Anda atau sesuai dengan ketentuan perundang-undangan yang berlaku.
        </li>

        <li>
          <strong>Pengolahan dan Analisis Data</strong>
          <br />
          Pengolahan dan analisis data pribadi Anda dilakukan sesuai dengan peraturan perlindungan data pribadi yang berlaku di Indonesia. Pengolahan ini hanya mencakup hal-hal yang telah kami sampaikan secara jelas pada saat data pribadi yang dikumpulkan dan diperoleh, dan akan dilakukan berdasarkan persetujuan pemiliki data.
        </li>

        <li>
          <strong>Penyimpanan Data</strong>
          <br />
          Data Anda akan disimpan sesuai dengan peraturan perlindungan data pribadi di Indonesia, setidaknya selama lima tahun setelah Anda berhenti menggunakan layanan kami. Data pribadi ini akan disimpan di pusat data dan pusat pemulihan bencana yang berlokasi di Indonesia. Data non-pribadi lainnya dapat disimpan di luar Indonesia dengan metode enkripsi dan tokenisasi, sehingga data tersebut tidak dapat diidentifikasi kepada Anda.
        </li>

        <li>
          <strong>Penampilan, Pengumuman, Pengiriman, Penyebarluasan, dan/atau Pembukaan Akses</strong>
          <br />
          Segala aktivitas yang melibatkan penampilan, pengumuman, pengiriman, penyebarluasan, atau pembukaan akses atas data pribadi Anda akan dilakukan sesuai dengan peraturan perlindungan data pribadi di Indonesia, dan hanya akan dilakukan berdasarkan persetujuan Anda sebagai pemilik data.
        </li>

        <li>
          <strong>Pemusnahan Data</strong>
          <br />
          Data pribadi Anda akan dimusnahkan apabila telah melewati periode penyimpanan yang ditentukan di atas atau atas permintaan Anda, sesuai dengan peraturan pelindungan data pribadi yang berlaku di Indonesia.
        </li>
      </ol>
    `,
  },
  {
    title: "Phishing",
    description: `
      <p>
        Pencurian identitas dan praktik yang saat ini dikenal sebagai "phishing" sangat memprihatinkan bagi Kami. Melindungi informasi untuk membantu melindungi Pengguna dari pencurian identitas adalah prioritas utama. Kami tidak dan tidak akan, sewaktu-waktu, meminta informasi kartu kredit Pengguna, kata sandi masuk atau nomor identifikasi nasional Pengguna melalui e-mail atau komunikasi telepon yang tidak aman atau tidak diminta.
      </p>
    `,
  },
  {
    title: "Ganti Rugi",
    description: `
      <p>
        Anda dengan ini menyatakan, menjamin, dan menyetujui bahwa setiap konten, data, informasi, maupun Informasi Pribadi yang Anda sampaikan melalui Layanan Kami adalah benar, akurat, tidak menyesatkan, serta diberikan dengan itikad baik, dan bahwa Anda memiliki hak yang sah untuk menyampaikannya kepada Kami. Anda dilarang mengunggah, mempublikasikan, atau dengan cara lain menyediakan konten melalui Situs Web atau Aplikasi yang dilindungi oleh hak cipta, merek dagang, atau hak kepemilikan lainnya milik pihak ketiga tanpa izin tertulis yang sah dari pemilik hak tersebut atau tanpa otoritas yang memadai.
      </p>

      <p>
        Segala kerugian yang timbul akibat pelanggaran hak cipta, merek dagang, atau hak kepemilikan lainnya, maupun kerugian lain yang diakibatkan oleh pengajuan informasi yang tidak sah, sepenuhnya menjadi tanggung jawab Anda. 
      </p>

      <p>
        Anda setuju untuk memberikan ganti rugi dan membebaskan Kami beserta perusahaan afiliasi, termasuk anggota dewan, direktur, pejabat, karyawan, agen, dan kontraktor, dari segala klaim, kerugian, biaya (termasuk biaya hukum yang wajar), maupun pengeluaran lain yang timbul secara langsung maupun tidak langsung akibat: a. Pelanggaran yang Anda lakukan sesuai dengan Kebijakan Privasi ini; b. Aktivitas Anda yang terkait dengan penggunaan Layanan, Situs Web atau Aplikasi; atau c. Informasi yang tidak diminta yang Anda sampaikan kepada Kami melalui Situs Web, Aplikasi, atau Layanan Kami. 
      </p>
    `,
  },
  {
    title: "Batasan Tanggung Jawab ",
    description: `
      <p>
        Kami tidak bertanggung jawab atas kerugian apa pun yang timbul dari atau terkait dengan penggunaan maupun ketidakmampuan untuk menggunakan Layanan, Situs Web, Aplikasi, atau konten dan tautan yang tersedia di dalamnya. Hal ini termasuk, namun tidak terbatas pada, kerugian yang diakibatkan oleh kesalahan, kelalaian, gangguan, cacat, keterlambatan dalam operasi atau transmisi, virus komputer, maupun kegagalan sistem atau jaringan.
      </p>

      <p>
        Kami juga tidak bertanggung jawab atas tindakan, kelalaian, atau perilaku pengguna maupun pihak ketiga lainnya. Lebih lanjut, Kami tidak bertanggung jawab atas kerugian tidak langsung, khusus, insidental, contoh, maupun konsekuensial, meskipun Kami telah diberitahu mengenai kemungkinan terjadinya kerugian tersebut. 
      </p>

      <p>
        Kami tidak bertanggung jawab atas pertukaran dan pemberian Data Pribadi yang dilakukan sendiri oleh Pengguna, termasuk yang dilakukan antar-Pengguna; termasuk dalam ketentuan ini adalah setiap dan segala kesalahan Pengguna yang mengakibatkan kebocoran Data Pribadi;   
      </p>

      <p>
        Kami tidak bertanggung jawab atas keaslian, keotentikan, kebenaran, keakuratan, kelengkapan Data Pribadi yang dimasukkan oleh Pengguna melalui Situs Web;  
      </p>

      <p>
        Dengan memberikan persetujuan melalui Situs, Pengguna melepaskan hak atas klaim, kerugian, tuntutan, dan gugatan yang mungkin terjadi atas perolehan, penyimpanan, penggunaan, pemanfaatan, dan/atau pengungkapan data, termasuk Data Pribadi jika dilakukan tidak sesuai dengan Kebijakan Privasi ini; 
      </p>

      <p>
        Kami tidak bertanggung jawab atas kebocoran Data Pribadi yang terjadi diakibatkan dan/atau terjadi selama karena Keadaan Memaksa. Keadaan Memaksa meliputi antara lain: (i) pemogokan, penutupan perusahaan, dan aksi industrial lain (ii) huru-hara, kerusuhan, invasi, serangan atau ancaman teroris, perang (baik yang dinyatakan atau tidak) atau ancaman persiapan perang; (iii) kebakaran, ledakan, badai, banjir, gempa bumi, epidemi atau bencana alam lain; (iv) tidak tersedianya atau terganggunya jaringan telekomunikasi, informatika dan/atau listrik; (v) terdapatnya kegagalan sistem yang diakibatkan pihak ketiga yang terjadi di luar wewenang kami; (vi) tidak berfungsinya sistem dan/atau jaringan perbankan, (vii) tindakan, putusan, undang-undang, peraturan atau pembatasan yang diterbitkan pemerintah 
      </p>
    `,
  },
];

export const COOKIES_INFORMATION_CONSTANT = [
  {
    title: "Apa Itu Cookies?",
    description: `
      <p>
        Cookies adalah potongan kecil data yang dikirim dari Situs Web untuk disimpan di perangkat pribadi Anda. Cookies memungkinkan Situs Web untuk mengenali perangkat Anda dan mengumpulkan informasi yang digunakan untuk menyesuaikan konten Situs Web sesuai dengan preferensi Anda. Kami menggunakan cookies melalui penyedia layanan pihak ketiga untuk meningkatkan pengalaman Anda saat mengakses Situs Web kami. 
      </p>
    `,
  },
  {
    title: "Cookies Apa yang Kami Gunakan?",
    description: `
      <ol style="list-style-type: lower-alpha;">
        <li>
          <strong>Cookies yang Sangat Diperlukan <i>(Strictly Necessary Cookies)</i></strong>
          <br />
          Tujuannya untuk memastikan Situs Web berfungsi dengan baik, memberikan berbagai fungsi dasar seperti navigasi halaman. Cookies ini disimpan selama satu tahun (persistent).
        </li>

        <li>
          <strong>Cookies Statistik</strong>
          <br />
          Tujuannya untuk melacak kebiasaan Anda dalam menggunakan Situs Web, termasuk frekuensi akses terhadap fungsi tertentu di Situs Web Kami. Masa penyimpanannya antara 1-2 tahun (persistent). Dalam beberapa kasus, kami mungkin menggunakan kedua jenis cookies ini melalui penyedia layanan pihak ketiga.
        </li>

        <li>
          <strong>Mengelola Cookies</strong>
          <br />
          Anda dapat mengelola, memblokir, dan menghapus cookies melalui pengaturan browser Anda. 
        </li>
      </ol>
    `,
  },
  {
    title: "Tautan Eksternal",
    description: `
      <p>
        Situs Web ini mungkin berisi tautan ke situs lain yang tidak berada di bawah kendali kami terkait privasi dan keamanan Anda. Adanya tautan tersebut tidak menjamin bahwa situs lain akan memberikan standar perlindungan data pribadi yang sama dengan yang kami terapkan dalam Kebijakan Privasi ini. Kami harapkan Anda membaca pemberitahuan privasi Situs Web lain saat Anda membuka situs pihak ketiga tersebut.  
      </p>

      <p>
        Kami tidak bertanggung jawab atas informasi, pengumpulan, penggunaan, pengungkapan atau kebijakan dan praktik keamanan organisasi lain termasuk Apple, Google, Facebook, Microsoft, RIM atau pengembang aplikasi, penyedia aplikasi, penyedia sistem operasi, penyedia layanan nirkabel lainnya. atau produsen perangkat Anda pada saat mengakses situs atau layanan Kami. 
      </p>
    `,
  },
  {
    title: "Perubahan Kebijakan Privasi",
    description: `
      <p>
        Kami berhak untuk mengubah Kebijakan Privasi ini sewaktu-waktu untuk mematuhi peraturan yang berlaku. Oleh karena itu, Anda disarankan untuk memeriksa bagian &ldquo;Tanggal Diperbarui&rdquo; pada Kebijakan Privasi secara berkala. Penggunaan Anda atas produk dan layanan kami setelah perubahan ini berarti Anda menerima versi pembaruan ini.
      </p>
    `,
  },
  {
    title: "Hubungi Kami Terkait Informasi Pribadi",
    description: `
      <p>
        Jika Anda memiliki pertanyaan, komentar, atau rekomendasi mengenai Kebijakan Privasi ini, silakan kirimkan ke:
      </p>

      <ul>
        <li>
          Email: support@lifepal.co.id.
        </li>

        <li>
          WhatsApp (Chat Only): 0823 300 300 27
        </li>

        <li>
          Nomor Telepon: 021 3076 2309
        </li>

        <li>
          Alamat Kantor: CIBIS 9, lt. 17,  Jl. TB Simatupang No.2 Cilandak Timur, Pasar Minggu Jakarta Selatan 12560
        </li>
      </ul>
    `,
  },
];

export const LANGUAGE_CONSTANT = [
  {
    title: "",
    description: `
      <p>
        Kebijakan Privasi ini dibuat dalam bahasa Indonesia dan dapat diterjemahkan ke Bahasa Inggris dan Bahasa Lainnya yang dianggap perlu. Jika terdapat perbedaan penafsiran antara teks bahasa Indonesia dan teks bahasa lain, maka teks Bahasa Indonesia yang akan berlaku. 
      </p>
    `,
  },
];
